<template>
  <div class="fbutton col">
    <button><slot /></button>
  </div>
</template>
<style lang="css" scoped>

</style>